import { Box, Divider } from "@mui/material";
import React from "react";
import Typography from '@mui/material/Typography';
import _ from "lodash";
import TextButtonComponet from "../../atom/Buttons/TextButton";
import moment from 'moment-timezone';
import openExternalUrl from "../../../core/openExternalUrl";

const TabItemFour = ({ itemFourData }) =>{
  const webinars = Array.isArray(itemFourData)
    ? itemFourData
    : itemFourData
      ? [itemFourData]
      : [];

  const getUserTimezone = () => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch {
      return "UTC";
    }
  };

  const convertToUserTime = (dateValue, timeValue, timeExt, apiTimezone) => {
    const defaultDate = dateValue ? moment(dateValue).format('DD MMM YYYY') : '';
    const defaultTime = timeValue ? moment(timeValue, "HH:mm:ss").format("hh:mm A") : '';
    if (!dateValue || !timeValue) return { date: defaultDate, time: defaultTime, timezone: getUserTimezone() };
    try {
      const userTz = getUserTimezone();

      const fullTimeStr = timeExt ? `${timeValue} ${timeExt}` : timeValue;
      const parseFormat = timeExt ? "YYYY-MM-DD hh:mm:ss A" : "YYYY-MM-DD HH:mm:ss";

      const sourceMoment = apiTimezone
        ? moment.tz(`${dateValue} ${fullTimeStr}`, parseFormat, apiTimezone)
        : moment(`${dateValue} ${fullTimeStr}`, parseFormat);

      const localMoment = sourceMoment.clone().tz(userTz);

      return {
        date: localMoment.format("DD MMM YYYY"),
        time: localMoment.format("hh:mm A"),
        timezone: localMoment.format("z"),
      };
    } catch {
      return { date: defaultDate, time: defaultTime, timezone: getUserTimezone() };
    }
  };

  const detailStyle = {
    fontFamily: 'Montserrat',
    fontSize: '22px',
    fontWeight: 600,
    textAlign: 'left',
    color: '#2d3945',
    marginBottom: '5px',
  };

  const now = moment();

  const processedWebinars = webinars.map((webinar) => {
    const dateVal = _.get(webinar, 'date', null);
    const timeVal = _.get(webinar, 'time', '');
    const timeExtVal = _.get(webinar, 'time_ext', '');
    const apiTzVal = _.get(webinar, 'timezone', null);
    const durationVal = Number(_.get(webinar, 'duration', 30)) || 30;

        const { date: localDate, time: localTime, timezone: localTimezone } =
      convertToUserTime(dateVal, timeVal, timeExtVal, apiTzVal);

    const displayDate = localDate || (dateVal ? moment(dateVal).format('DD MMM YYYY') : '');
    const displayTime = localTime || (timeVal ? moment(timeVal, 'HH:mm').format('hh:mm A') : '');

    const webinarStart = webinar?.webinar_datetime ? moment(webinar.webinar_datetime) : null;
    const webinarEnd = webinar?.end_datetime ? moment(webinar.end_datetime) : null;
    const isLive = webinarStart && webinarEnd ? now.isBetween(webinarStart, webinarEnd) : false;

    return {
      ...webinar,
      displayDate,
      displayTime,
      localTimezone,
      durationVal,
      isLive,
    };
  });

  const liveWebinars = processedWebinars.filter(w => w.isLive);
  const upcomingWebinars = processedWebinars.filter(w => !w.isLive);

  const renderWebinarCard = (webinar, index) => (
          <Box key={webinar?.id ?? index} gap={2} sx={{ marginBottom: 3 }}>
            {index > 0 && <Divider sx={{ my: 2 }} />}
            <Typography component="p" sx={detailStyle}>
              Class Name - {_.get(webinar, 'name', '')}
            </Typography>
            <Typography component="p" sx={detailStyle}>
              Note - {String(_.get(webinar, 'note', '') || '').trim() || 'N/A'}
            </Typography>
            <Typography component="p" sx={detailStyle}>
              Date - {webinar.displayDate}
            </Typography>
            <Typography component="p" sx={detailStyle}>
              Time - {webinar.displayTime} {webinar.localTimezone ? `(${webinar.localTimezone})` : ''}
            </Typography>
            <Typography component="p" sx={detailStyle}>
              Duration - {webinar.durationVal} minutes
            </Typography>
          <Box sx={{width: 250, marginTop: 2, marginBottom: 2 }}>
          <TextButtonComponet onButtonClick={() => {
                          openExternalUrl(webinar?.join_url);
                        }}
        text={'Click here to Join'}/>
          </Box>
                </Box>
            );

          return (
            <Box>
              {/* Live Class Section */}
              {liveWebinars.length > 0 && (
                <Box sx={{ marginBottom: 4 }}>
                  <Box
                    sx={{
                      display: "inline-block",
                      backgroundColor: "#E2535D",
                      color: "#ffffff",
                      padding: "6px 16px",
                      borderRadius: "20px",
                      marginBottom: "15px",
                    }}
                  >
                    <Typography style={{ display: 'flex', flexDirection: 'column' }} fontSize={17} fontWeight={800}>
                      Live Class
                    </Typography>
                  </Box>
                  {liveWebinars.map((webinar, index) => renderWebinarCard(webinar, index))}
                </Box>
              )}

              {/* Distinct Divider Between Live and Upcoming Sections */}
              {liveWebinars.length > 0 && upcomingWebinars.length > 0 && (
                <Divider 
                  sx={{ 
                    my: 4, 
                    borderColor: "#8a4bc1", 
                    borderWidth: "1.5px", 
                    opacity: 0.6 
                  }} 
                />
              )}

              {/* Upcoming Class Section */}
              {upcomingWebinars.length > 0 && (
                <Box>
                  <Box
                    sx={{
                      display: "inline-block",
                      backgroundColor: "#9834F0",
                      color: "#ffffff",
                      padding: "6px 16px",
                      borderRadius: "20px",
                      marginBottom: "15px",
                    }}
                  >
                    <Typography style={{ display: 'flex', flexDirection: 'column' }} fontSize={17} fontWeight={800}>
                      Upcoming Class
                    </Typography>
                  </Box>
                  {upcomingWebinars.map((webinar, index) => renderWebinarCard(webinar, index))}
                </Box>
              )}
            </Box>
          );
}

export default TabItemFour;